<div>
    <div [class]="target"></div>
</div>